import { render, staticRenderFns } from "./UnpaidOrder.vue?vue&type=template&id=5ff23310&scoped=true"
import script from "./UnpaidOrder.vue?vue&type=script&lang=js"
export * from "./UnpaidOrder.vue?vue&type=script&lang=js"
import style0 from "./UnpaidOrder.vue?vue&type=style&index=0&id=5ff23310&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff23310",
  null
  
)

export default component.exports